import { LoadingState } from 'Components/LoadingState/LoadingState'

export const SearchLoadingState = () => <LoadingState height={500} />
